import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import InlineIcon from '../InlineIcon/InlineIcon.jsx'
import './Toast.scss'

function Toast(props) {
  const { message, count = 1, onClose } = props
  const type = props.type.toLowerCase()
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 5000) // Automatically close the toast after 5 seconds

    return () => clearTimeout(timer)
  }, [onClose])

  const isNegative = type === 'negative' || type === 'error'
  const isPositive = type === 'positive' || type === 'success'
  const hasIcon = () => isNegative || isPositive

  return (
    <div className={`toast ${type}`}>
      <div className='toast__message'>
        {hasIcon() && (
          <InlineIcon
            name={isNegative ? 'alert-circle' : 'check-circle'}
            className='toast__front-icon'
          />
        )}
        <div className='toast__content' title={message}>
          {message}
          {/* Repeats are collapsed into one toast rather than queued, so the
              count is the only signal that this happened more than once. */}
          {count > 1 && (
            <span className='repeat-count' data-testid='toast-repeat-count'>
              ×{count}
            </span>
          )}
        </div>
        <button
          type='button'
          className='toast__close'
          aria-label='Dismiss notification'
          onClick={onClose}
        >
          <InlineIcon name='close' />
        </button>
      </div>
    </div>
  )
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  count: PropTypes.number,
  type: PropTypes.oneOf([
    'negative',
    'error',
    'positive',
    'success',
    'info',
    'warning',
    'Negative',
    'Error',
    'Positive',
    'Success',
    'Info',
    'Warning',
  ]),
  onClose: PropTypes.func,
}

export default Toast
